if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      hide() {
        super.hide();
      }

      show(opener) {
        if (!opener || typeof opener.getAttribute !== 'function') return;
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const opener = this.openedBy;
        if (!opener || typeof opener.getAttribute !== 'function') return;

        const mediaId = opener.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          if (element.getAttribute('data-media-id') !== mediaId) element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${CSS.escape(mediaId)}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'nearest' });

        const container = this.querySelector('[role="document"]');
        if (container) {
          const width = activeMedia.getBoundingClientRect().width || activeMedia.clientWidth || 0;
          container.scrollLeft = Math.max(0, (width - container.clientWidth) / 2);
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent?.querySelector('.js-youtube') &&
          typeof activeMedia.loadContent === 'function'
        ) activeMedia.loadContent();
      }
    }
  );
}
